import TituloAtraso from './TituloAtraso';

export default TituloAtraso;